import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-email-selection-popup',
    templateUrl: './email-selection-popup.component.html',
    styleUrls: ['./email-selection-popup.component.sass'],
    standalone: false
})

export class EmailSelectionPopupComponent {

  selectedUser: any = null;

  constructor(private dialogRef: MatDialogRef<EmailSelectionPopupComponent>, 
              @Inject(MAT_DIALOG_DATA) public data: { userData: any[], offer: string }) { }

  confirmSelection() {
    if(this.selectedUser) {
      this.dialogRef.close(this.selectedUser);
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

}